export const LOGOUT_EVENT = 'LOGOUT';